<app-dialog 
    [title]="dialogData.title ? dialogData.title : locationSummaryId ? 'Adjust Stock Qty' : 'Add New Warehouse Qty'" 
    [actions]="[
		{ text: 'Cancel', buttonStyle: 'underline' },
		{ text: locationSummaryId ? 'Update' : 'Save', spin: spin, isDisabled: !this.whLocationForm.valid || spin ||
         ((updateQty.value > dialogData.qty) && !isAdditionSign.value) || ((updateQty.value == null  || updateQty.value==0) && locationSummaryId)  }
	]" 
    (close)="dialogRef.close()" 
(action)="action($event)"
>
    <div class="warehouse" [formGroup]="whLocationForm">

        <div class="input-container warehouse-select mt-3" *ngIf="headerService.useBinLocation || !dialogData.locationSummaryId">
            <label for="" class="input-container_label">Warehouse<span class="input-container_asterisk">*</span></label>
            
              <mat-form-field appearance="fill" class="custom-mat-select" [ngClass]="{'disabled': dialogData.WarehouseId}">
                <mat-select class="input-container_input input-container_input--select" formControlName="warehouseId" >
                    <mat-option [value]="0" selected>Select Warehouse</mat-option>

                   <mat-option *ngFor="let wh of whs" [value]="wh.warehouseId">

                        {{ wh.id }}</mat-option>
                  </mat-select>
              </mat-form-field>
              <div class="input-container_error-message text-end" *ngIf="hasNoWhs">
                No carries-inventory warehouse found
              </div>
        </div>
           <div class="input-container mt-2" *ngIf="headerService.useBinLocation">
                <label for="" class="input-container_label">Location Code</label>
                <mat-form-field appearance="fill" class="custom-mat-select">
                <mat-select class="input-container_input input-container_input--select" [disabled]="dialogData.WarehouseId" formControlName="locationCode" [ngClass]="{'disabled': dialogData.WarehouseId }">
                   <mat-option *ngFor="let location of locations" [value]="location">
                        {{ location.locationCode }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- <input type="text" attr.disabled="{{dialogData.WarehouseId}}" class="input-container_input"formControlName="locationCode" placeholder="" /> -->
            </div>

            <div class="input-container mt-2">
            <div class="d-flex justify-content-between">
                <label for="" class="input-container_label">Item<span class="input-container_asterisk">*</span></label>
            </div>
            <input type="text" class="input-container_input" [readonly]="isProductdisable || dialogData.locationSummaryId " formControlName="autocomplete" [matAutocomplete]="auto"  (click)="setScroll()">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" >
                <mat-option *ngFor="let option of filteredOptions$ " [value]="option" class="mat-option-override">
                    <app-item-typeahead [name]="option.title" [sku]="option.sku" [id]="option.name" [image]="option.imageUrl">
                    </app-item-typeahead>
                </mat-option>
            </mat-autocomplete>
        </div>

        <div class="input-container mt-2" *ngIf="locationSummaryId">
            <label for="" class="input-container_label"> Update Qty<span class="input-container_asterisk"></span></label>
            <div class="discount-price">
                <input type="number" class="input-container_input discount-price_input" [formControl]="updateQty"
                    placeholder="" (change)="onChange()" (keypress)="onlyNumberKey($event)" min="0">
                <div class="discount-price_select">
                    <mat-select [formControl]="isAdditionSign" (selectionChange)="onChange()" panelClass="AdditionSign">
                        <mat-option [value]=true><span>+</span></mat-option>
                        <mat-option [value]=false><span>-</span></mat-option>
                    </mat-select>
                </div>
            </div>            
        </div>
          
        <div class="input-container mt-2">
            <label for="" class="input-container_label"> Total Qty<span class="input-container_asterisk">*</span></label>
            <input type="number" class="input-container_input"  formControlName="qty" #qtyInput min="0" placeholder="" (keypress)="onlyNumberKey($event)">
            <div class="text-warning" *ngIf="whLocationForm.get('qty').value < 0 ">Total qty is less than 0</div>
        </div>
       
        
            <div class="input-container mt-3" *ngIf="locationSummaryId">
                <label for="" class="input-container_label">Reason<span class="input-container_asterisk">*</span></label>
                <input type="text" class="input-container_input" formControlName="action" placeholder=""/>
                
            </div>


        <!-- <div class="form-input-info">
            <svg xmlns="http://www.w3.org/2000/svg" width="8.461" height="8.461" viewBox="0 0 8.461 8.461">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle"
                    d="M9.024,4.793A4.231,4.231,0,1,1,4.793.563,4.23,4.23,0,0,1,9.024,4.793ZM4.907,1.961A2.21,2.21,0,0,0,2.918,3.049a.2.2,0,0,0,.046.277l.592.449a.2.2,0,0,0,.284-.036c.3-.387.514-.611.978-.611.349,0,.78.224.78.562,0,.255-.211.387-.555.58-.4.225-.932.5-.932,1.205v.068a.2.2,0,0,0,.2.2h.955a.2.2,0,0,0,.2-.2V5.521c0-.486,1.419-.506,1.419-1.82A1.946,1.946,0,0,0,4.907,1.961ZM4.793,6.192a.785.785,0,1,0,.785.785A.786.786,0,0,0,4.793,6.192Z"
                    transform="translate(-0.563 -0.563)" fill="#7b7b7b" />
            </svg>
            <span>Recommended format is aisle [number]-side[R/L]-shelf[number]-bin[letter] example : 5-L-N-4</span>
        </div> -->

    </div>
</app-dialog>